module.exports = __webpack_public_path__ + "static/media/play-store.7a008610.svg";